import { render, staticRenderFns } from "./AppAdmin.vue?vue&type=template&id=29e54394&scoped=true&"
import script from "./AppAdmin.vue?vue&type=script&lang=ts&"
export * from "./AppAdmin.vue?vue&type=script&lang=ts&"
import style0 from "./AppAdmin.vue?vue&type=style&index=0&id=29e54394&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e54394",
  null
  
)

export default component.exports